import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';

Swiper.use([Navigation, Pagination, A11y]);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector('.image-slider__carousel'),
      cards: this.el.querySelectorAll('.image-card'),
      buttons: this.el.querySelectorAll('.image-card__slider-btn')
    };

    this.initSlider();
    this.makeButtonsNotFocusable();
    if (this.dom.cards.length > 1) this.setPagination(0, this.dom.cards.length);
  }

  addListeners() {
    this.dom.cards.forEach(card => {
      const nextButton = card.querySelector('.swiper-button-next');
      const prevButton = card.querySelector('.swiper-button-prev');
      nextButton.addEventListener('keydown', e => this.keyPress(e));
      prevButton.addEventListener('keydown', e => this.keyPress(e));
    });
  }

  keyPress(e) {
    if (e.keyCode === 13) {
      if (e.target.classList.contains('swiper-button-next')) {
        this.swiper.slideNext();
      } else if (e.target.classList.contains('swiper-button-prev')) {
        this.swiper.slidePrev();
      }
      this.setActivePagination();
    }
  }

  setActivePagination() {
    const activeSlide = this.el.querySelector('.swiper-slide-active');
    const totalSlides = this.swiper.slides.length;
    this.setPagination(
      Number(activeSlide.dataset.swiperSlideIndex),
      totalSlides
    );
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.swiperContainer, {
      keyboard: true,
      autoHeight: false,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        navigationNext: () => {
          this.setActivePagination();
        },
        navigationPrev: () => {
          this.setActivePagination();
        },
        transitionEnd: () => {
          this.setActivePagination();
        }
      }
    });
  }

  makeButtonsNotFocusable() {
    this.dom.buttons.forEach(button => {
      button.style.display = 'none';
    });
  }

  setPagination(activeSlide, totalSlides) {
    const paginationContainers = this.el.querySelectorAll(
      '.image-card__pagination-count'
    );
    this.makeButtonsNotFocusable();
    const activeCard = this.dom.cards[activeSlide]
    const buttons = activeCard.querySelectorAll('.image-card__slider-btn')
    buttons.forEach(button => {
      button.style.display = 'block';
    })

    paginationContainers.forEach(container => {
      container.innerHTML = `${activeSlide + 1} / ${totalSlides}`;
    });
  }
}

export default Module;
